import { useState, useEffect } from"react";

const DEFAULT_SESSION = {
 technology:"",
 topic:"",
 level: 1,
 mode:"practice", // or 'test' or 'interview'
 language:"en"
};

const useSkillGenieSession = () => {
 const [session, setSession] = useState(() => {
 const saved = localStorage.getItem("skillgenie_session");
 return saved ? JSON.parse(saved) : DEFAULT_SESSION;
 });

 useEffect(() => {
 localStorage.setItem("skillgenie_session", JSON.stringify(session));
 }, [session]);

 const updateSession = (updates) => {
 setSession((prev) => ({ ...prev, ...updates }));
 };

 const resetSession = () => {
 setSession(DEFAULT_SESSION);
 };

 return {
 session,
 updateSession,
 resetSession
 };
};

export default useSkillGenieSession;



